module.exports = __webpack_public_path__ + "static/img/SketchPng58feb21f9a5ede3d0286a9fbf605e4ce98141693780cb9b020cfaff4aa2d102a.0e8bd2bc.png";